var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayNewEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.26 20.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        stroke-width: 1.2px;\n      }\n\n      .b, .c {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .c {\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.99,2.99H3c-1.24,0-2.25,1.01-2.25,2.25v12c0,1.24,1.01,2.25,2.25,2.25h12c1.24,0,2.25-1.01,2.25-2.25v-9.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.9,
    y1: 13.13,
    x2: 8.9,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.9,
    y1: 5,
    x2: 11.03,
    y2: 7.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.9,
    y1: 5,
    x2: 6.77,
    y2: 7.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8.9,
    cy: 16.27,
    r: 1.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 12.79,
    cy: 9.71,
    r: 1.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 12.74,
    y1: 13.86,
    x2: 13.81,
    y2: 12.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 12.74,
    y1: 13.86,
    x2: 13.81,
    y2: 14.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 11.68,
    y1: 12.79,
    x2: 12.74,
    y2: 13.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 11.68,
    y1: 14.92,
    x2: 12.74,
    y2: 13.86
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.21,
    cy: 14.12,
    r: 1.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 5.26,
    y1: 9.97,
    x2: 4.19,
    y2: 11.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 5.26,
    y1: 9.97,
    x2: 4.19,
    y2: 8.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.32,
    y1: 11.04,
    x2: 5.26,
    y2: 9.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 6.32,
    y1: 8.9,
    x2: 5.26,
    y2: 9.97
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 15.02,
    y1: 2.99,
    x2: 19.51,
    y2: 2.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 17.26,
    y1: 0.75,
    x2: 17.26,
    y2: 5.23
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNewEdit);
export default __webpack_public_path__ + "static/media/play-new-edit.038ca67250d88a25a619cc2fdaba7cee.svg";
export { ForwardRef as ReactComponent };